import LoadingButton from '@mui/lab/LoadingButton';
import { IconProps, SxProps } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';
import React from 'react';

interface IAppButtonProps extends ButtonProps {
  label: string;
  isLoading?: boolean;
  onClick?: VoidFunction;
  linkCompoennt?: any;
  href?: string;
  type?: 'button' | 'submit';
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  sx?: SxProps;
  buttonIcon?: React.ReactElement<IconProps>;
}

const AppButton: React.FC<IAppButtonProps> = (props) => {
  const {
    label,
    isLoading = false,
    onClick,
    linkCompoennt,
    href,
    type = 'button',
    variant = 'contained',
    color = 'secondary',
    sx,
    buttonIcon,
    ...other
  } = props;

  return (
    <LoadingButton
      loading={isLoading}
      onClick={onClick}
      LinkComponent={linkCompoennt}
      href={href}
      type={type}
      variant={variant}
      color={color}
      sx={{ ...sx }}
      startIcon={buttonIcon}
      {...other}
    >
      {label}
    </LoadingButton>
  );
};

export default AppButton;
